import { render } from "./ReportOrderByTime.vue?vue&type=template&id=1efcb904&scoped=true"
import script from "./ReportOrderByTime.vue?vue&type=script&lang=js"
export * from "./ReportOrderByTime.vue?vue&type=script&lang=js"

import "./ReportOrderByTime.vue?vue&type=style&index=0&id=1efcb904&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1efcb904"

export default script